import { React, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
    getPAAAA010,
    getPAGAA000,
    postPAIAE010Choice,
    postPAIAE010DelChoice,
    putPAAAA010Banner,
    putPAAAA010ClickBanner,
} from '../../services/Api';
import Carousel from '../../shared/components/Carousel';
import ImageCheckFallback from '../../shared/components/ImageCheckFallback';
import { decodeToken, formatDate, getImageSrc, hideName, shouldDisplayMenu } from '../../utils';
import Loader from '../../shared/components/Loader';
import { decodeHTML } from 'entities';
import MobileBannerSlider from './MobileBannerSlider';
const PAAAA010 = () => {
    const navigator = useNavigate();
    const [loading, setLoading] = useState(false);
    const token = useSelector(({ auth }) => auth.login.token);
    const login = useSelector(({ auth }) => auth.login);
    const loggedIn = login.loggedIn;
    const [menuData, setMenuData] = useState([]);

    const decode = decodeToken(token);
    const [currentAnnouncementIndex, setCurrentAnnouncementIndex] = useState(0);
    const [announcements, setAnnouncements] = useState([]);
    const [resumesData, setResumesData] = useState([]);
    const currentAnnouncement = announcements[currentAnnouncementIndex];
    const [mainBanner, setMainBanner] = useState([]);
    const [grandBanner, setGrandBanner] = useState([]);
    const [premiumBanner, setPremiumBanner] = useState([]);
    const [hotBanner, setHotBanner] = useState([]);
    const [corpBanner, setCorpBanner] = useState([]);
    const [recruitGrand, setRecruitGrand] = useState([]);
    const [recruitPremium, setRecruitPremium] = useState([]);
    const [recruitHot, setRecruitHot] = useState([]);
    const [recruitCorporate, setRecruitCorporate] = useState([]);
    const [recruitBusiness, setRecruitBusiness] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!loading) {
            window.scrollTo(0, 0);
        }
    }, [loading, location.pathname]);

    const handleTextAnnouncement = (direction) => {
        if (direction === 'next') {
            setCurrentAnnouncementIndex((prev) => (prev + 1) % announcements.length);
        } else if (direction === 'prev') {
            setCurrentAnnouncementIndex((prev) => (prev - 1 + announcements.length) % announcements.length);
        }
    };

    const getNewsTitle = async () => {
        try {
            setLoading(true);
            const { data } = await getPAAAA010();
            setAnnouncements(data?.news ?? []);
            setResumesData(data ? data.resumes : []);
            setMainBanner(data ? data.main : []);
            setGrandBanner(data ? data.grand : []);
            setPremiumBanner(data ? data.premium : []);
            setHotBanner(data ? data.mainResume : []);
            setCorpBanner(data?.corp ?? []);
            setRecruitGrand(data ? data.recruitGrand : []);
            setRecruitPremium(data ? data.recruitPremium : []);
            setRecruitHot(data ? data.recruitHot : []);
            setRecruitCorporate(data ? data.recruitCorporate : []);
            setRecruitBusiness(data ? data.recruitBusiness : []);
            const listSeq = [
                data?.main?.map((item) => item.seq).join(','),
                data?.grand?.map((item) => item.seq).join(','),
                data?.grandSub?.map((item) => item.seq).join(','),
                data?.premium?.map((item) => item.seq).join(','),
                data?.resume?.map((item) => item.seq).join(','),
            ]
                .filter((seq) => seq)
                .join(',');
            if (listSeq.toString() === '') return;
            putPAAAA010Banner(listSeq.toString())
                .then()
                .catch((error) => console.log(error));

            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    };

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                setMenuData(data);
            })
            .catch((error) => console.log(error));

        getNewsTitle();
    }, []);

    const ResumeClassDisplay = (resumeClass) => {
        if (!resumeClass) {
            return '';
        }

        const classes = resumeClass.split(',').map((cls) => cls.trim());

        if (classes.length <= 2) {
            return <span>{classes.join(' | ')}</span>;
        } else {
            const firstTwo = classes.slice(0, 2).join(' | ');
            return <span>{firstTwo} 외</span>;
        }
    };

    const removeStar = (item, setList) => {
        if (!loggedIn) {
            alert('로그인 후 이용가능합니다.');
            return;
        }
        postPAIAE010DelChoice(item.choiceSeq)
            .then(() => {
                setList((prevList) =>
                    prevList.map((listItem) => (listItem.seq === item.seq ? { ...listItem, isChoice: 'N' } : listItem)),
                );
            })
            .catch((error) => console.log(error));
    };

    const activeStarResume = (item, setList) => {
        if (!loggedIn) {
            alert('로그인 후 이용가능합니다.');
            return;
        } else if (decode?.authorities === 'ROLE_P') {
            alert('치과회원만 이용가능합니다.');
            return;
        }
        postPAIAE010Choice({ tblName: 'Resume', refSeq: item.seq, memberID: decode?.memberID })
            .then(({ data }) => {
                setList((prevList) =>
                    prevList.map((listItem) =>
                        listItem.seq === item.seq ? { ...listItem, isChoice: 'Y', choiceSeq: data.seq } : listItem,
                    ),
                );
            })
            .catch((error) => console.log(error));
    };

    const activeStarRecruit = (item, setList) => {
        if (!loggedIn) {
            alert('로그인 후 이용가능합니다.');
            return;
        } else if (decode?.authorities === 'ROLE_C') {
            alert('개인회원만 이용가능합니다.');
            return;
        }
        postPAIAE010Choice({ tblName: 'Recruit', refSeq: item.seq, memberID: decode?.memberID })
            .then(({ data }) => {
                setList((prevList) =>
                    prevList.map((listItem) =>
                        listItem.seq === item.seq ? { ...listItem, isChoice: 'Y', choiceSeq: data.seq } : listItem,
                    ),
                );
            })
            .catch((error) => console.log(error));
    };

    const handleDropList = () => {
        navigator('/pafaa010');
        window.scrollTo(0, 0);
    };

    /*
    const handleDetail = (id, path) => {
        if (window.location.pathname !== '/login' && id && !loggedIn) {
            if (window.confirm(`회원전용입니다.\n로그인 하신후 이용하실 수 있습니다.\n로그인하시겠습니까?`)) {
                navigate('/login', { state: { id, path } });
            } else {
                alert(`회원이 아닌경우 회원가입후 이용가능합니다.`);
                navigate('/');
            }
        }
    };
    */

    const handleCountClickBanner = async (seq) => {
        await putPAAAA010ClickBanner(seq);
    };

    const RecruitLogoChecking = ({ folderName, imgName, src, alt, bizCompany }) => {
        const [hasError, setHasError] = useState(false);

        const handleError = () => {
            setHasError(true);
        };

        return (
            <>
                {imgName && !hasError ? (
                    <img
                        src={src || getImageSrc(folderName, imgName)}
                        alt={alt || bizCompany || 'image'}
                        onError={handleError}
                    />
                ) : (
                    <span style={{ fontSize: 19, fontWeight: 600, paddingTop: 20, textAlign: 'center' }}>
                        {bizCompany || '치과명없음'}
                    </span>
                )}
            </>
        );
    };

    const BusinessHoverLogo = ({ folderName, imgName, src, alt, classImg }) => {
        const [hasError, setHasError] = useState(false);
        const transparentPixel = './images/default_logo.jpg';

        const handleError = () => {
            setHasError(true);
        };

        if (!imgName || hasError) {
            return (
                <img
                    className={classImg || ''}
                    src={transparentPixel}
                    alt="no image"
                />
            );
        }

        return (
            <img
                className={classImg || ''}
                src={src || getImageSrc(folderName, imgName)}
                alt={alt || 'image'}
                onError={handleError}
            />
        );
    };


    return (
        <div id="content" className="home-content">
            {/* Hero */}
            <div id="hero">
                <div className="container">
                    {/*	Slider	*/}
                    <div id="slide">
                        <Carousel dataSlide={mainBanner} dataName="Home" />
                        {/*mainBanner mobile */}
                        <MobileBannerSlider mainBanner={mainBanner} handleCountClickBanner={handleCountClickBanner} />
                    </div>
                    {/*mainBanner desktop */}
                    {/*	End Slider	*/}
                    {/* Hero menu */}
                    <div id="hero-menu">
                        <ul>
                            <li>
                                <Link to="/pahac010">
                                    <i className="icon icon-check" />
                                    <span>이용안내</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/pahab010">
                                    <i className="icon icon-mess" />
                                    <span>상품안내</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/pahaa010">
                                    <i className="icon icon-phone" />
                                    <span>고객센터</span>
                                </Link>
                            </li>
                            {shouldDisplayMenu('pagaj010', menuData) && (
                                <li>
                                    <Link to="/pagaj010">
                                        <i className="icon icon-edu" />
                                        <span>법정 의무교육</span>
                                    </Link>
                                </li>
                            )}
                            {shouldDisplayMenu('pagaa010', menuData) && (
                                <li>
                                    <Link to="/pagaa010">
                                        <i className="icon icon-heart" />
                                        <span>자원봉사</span>
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </div>
                    {/* End Hero menu */}
                </div>
            </div>
            {/* End Hero */}
            {/* Slide NEWS */}
            <div id="slide-news">
                <div className="container">
                    <div className="slide-news-wrap">
                        <div className="left-slide">
                            <h1>
                                {currentAnnouncement?.gubun === '01' && '공지사항'}
                                {currentAnnouncement?.gubun === '02' && '뉴스'}
                            </h1>
                            <Link to={`/pahaf020-${currentAnnouncement?.seq}`}>{currentAnnouncement?.title}</Link>
                        </div>
                        <div className="right-slide">
                            <p>{formatDate(currentAnnouncement?.addDate)}</p>
                            <div className="control-container">
                                <button
                                    className="control control-prev"
                                    type="button"
                                    onClick={() => {
                                        handleTextAnnouncement('prev');
                                    }}
                                >
                                    <i className="icon icon-black-prev" />
                                </button>
                                <button
                                    className="control control-next"
                                    type="button"
                                    onClick={() => {
                                        handleTextAnnouncement('next');
                                    }}
                                >
                                    <i className="icon icon-black-next" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* End Slide NEWS */}
            {/* Grand Banner */}
            <div id="grand-banner">
                <div className="container">
                    <h1 className="section-title">그랜드</h1>
                    <div className="list-grid">
                        {grandBanner && grandBanner?.length > 0 && (
                            <div className="list-item list-item-1 slide GrandSlideBanner" style={{ height: '442px' }}>
                                <Carousel dataSlide={grandBanner} dataName="GrandSlide" />
                            </div>
                        )}
                        {recruitBusiness && recruitBusiness.length > 0 && (
                            <div
                                className={`list-item ${grandBanner?.length > 0 ? 'list-item-2' : 'list-item-1'
                                    } large-full`}
                            >
                                <div className="item-content">
                                    <div className="item-main-content">
                                        <div className="item-logo">
                                            <RecruitLogoChecking
                                                folderName={'recruit_logo'}
                                                imgName={recruitBusiness[0].logo}
                                                alt="logo recruitBusiness"
                                                bizCompany={recruitBusiness[0].bizCompany}
                                            />
                                        </div>
                                        <div className="item-desc">{recruitBusiness[0].title}</div>
                                        <div className="item-tag">
                                            {recruitBusiness[0].recruitClass &&
                                                recruitBusiness[0].recruitClass.includes(',')
                                                ? recruitBusiness[0].recruitClass.split(',')[0] + ' 외'
                                                : recruitBusiness[0].recruitClass}{' '}
                                            | {recruitBusiness[0].regionSi}({recruitBusiness[0].regionGu}) |{' '}
                                            {recruitBusiness[0].recruitForm &&
                                                recruitBusiness[0].recruitForm.includes(',')
                                                ? recruitBusiness[0].recruitForm.split(',')[0] + ' 외'
                                                : recruitBusiness[0].recruitForm}
                                        </div>
                                        <button
                                            className="bookmark"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                recruitBusiness[0].isChoice === 'Y'
                                                    ? removeStar(recruitBusiness[0], setRecruitBusiness)
                                                    : activeStarRecruit(recruitBusiness[0], setRecruitBusiness);
                                            }}
                                        >
                                            <i
                                                className={`icon icon-star ${recruitBusiness[0].isChoice === 'Y' ? 'active' : ''
                                                    }`}
                                            />
                                        </button>
                                        <div className="item-image">
                                            <ImageCheckFallback
                                                folderName={'recruit_photo'}
                                                imgName={recruitBusiness[0]?.subBizImg?.split('|')[0]}
                                                alt="business banner"
                                            />
                                        </div>
                                    </div>
                                    <div className="item-hover-content">
                                        <a
                                            href={`/paeaa070-${recruitBusiness[0].seq}?bs=${recruitBusiness[0].bannerSeq}`}
                                            className="content-banner-hover"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                backgroundImage: `url(${getImageSrc(
                                                    'recruit_photo',
                                                    recruitBusiness[0]?.subBizImg?.split('|')[0],
                                                )})`,
                                            }}
                                        >
                                            <div className="content-banner-hover-logo">
                                                <RecruitLogoChecking
                                                    folderName={'recruit_logo'}
                                                    imgName={recruitBusiness[0].logo}
                                                    alt="logo recruitBusiness"
                                                    bizCompany={recruitBusiness[0].bizCompany}
                                                />
                                            </div>

                                            <div className="content-banner-hover-title">
                                                {recruitBusiness[0].bizCompany}
                                            </div>

                                            <div className="content-banner-hover-desc">
                                                {recruitBusiness[0].title}
                                            </div>
                                        </a>
                                        <button
                                            className="bookmark"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                recruitBusiness[0].isChoice === 'Y'
                                                    ? removeStar(recruitBusiness[0], setRecruitBusiness)
                                                    : activeStarRecruit(recruitBusiness[0], setRecruitBusiness);
                                            }}
                                        >
                                            <i
                                                className={`icon icon-star white ${recruitBusiness[0].isChoice === 'Y' ? 'active' : ''
                                                    }`}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                        {recruitBusiness && recruitBusiness.length > 1 && (
                            <div
                                className={`list-item ${grandBanner?.length > 0 ? 'list-item-3' : 'list-item-2'
                                    } large-full`}
                            >
                                <div className="item-content">
                                    <div className="item-main-content">
                                        <div className="item-logo">
                                            <RecruitLogoChecking
                                                folderName={'recruit_logo'}
                                                imgName={recruitBusiness[1].logo}
                                                alt="logo recruitBusiness"
                                                bizCompany={recruitBusiness[1].bizCompany}
                                            />
                                        </div>
                                        <div className="item-desc">{recruitBusiness[1].title}</div>
                                        <div className="item-tag">
                                            {recruitBusiness[1].recruitClass &&
                                                recruitBusiness[1].recruitClass.includes(',')
                                                ? recruitBusiness[1].recruitClass.split(',')[0] + ' 외'
                                                : recruitBusiness[1].recruitClass}{' '}
                                            | {recruitBusiness[1].regionSi}({recruitBusiness[1].regionGu}) |{' '}
                                            {recruitBusiness[1].recruitForm &&
                                                recruitBusiness[1].recruitForm.includes(',')
                                                ? recruitBusiness[1].recruitForm.split(',')[0] + ' 외'
                                                : recruitBusiness[1].recruitForm}
                                        </div>
                                        <button
                                            className="bookmark"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                recruitBusiness[1].isChoice === 'Y'
                                                    ? removeStar(recruitBusiness[1], setRecruitBusiness)
                                                    : activeStarRecruit(recruitBusiness[1], setRecruitBusiness);
                                            }}
                                        >
                                            <i
                                                className={`icon icon-star ${recruitBusiness[1].isChoice === 'Y' ? 'active' : ''
                                                    }`}
                                            />
                                        </button>
                                        <div className="item-image">
                                            <ImageCheckFallback
                                                folderName={'recruit_photo'}
                                                imgName={recruitBusiness[1]?.subBizImg?.split('|')[0]}
                                                alt="business banner"
                                            />
                                        </div>
                                    </div>
                                    <div className="item-hover-content">
                                        <a
                                            href={`/paeaa070-${recruitBusiness[1].seq}?bs=${recruitBusiness[1].bannerSeq}`}
                                            className="content-banner-hover"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                backgroundImage: `url(${getImageSrc(
                                                    'recruit_photo',
                                                    recruitBusiness[1]?.subBizImg?.split('|')[0],
                                                )})`,
                                            }}
                                        >
                                            <div className="content-banner-hover-logo">
                                                <RecruitLogoChecking
                                                    folderName={'recruit_logo'}
                                                    imgName={recruitBusiness[1].logo}
                                                    alt="logo recruitBusiness"
                                                    bizCompany={recruitBusiness[1].bizCompany}
                                                />
                                            </div>

                                            <div className="content-banner-hover-title">
                                                {recruitBusiness[1].bizCompany}
                                            </div>

                                            <div className="content-banner-hover-desc">
                                                {recruitBusiness[1].title}
                                            </div>
                                        </a>
                                        <button
                                            className="bookmark"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                recruitBusiness[1].isChoice === 'Y'
                                                    ? removeStar(recruitBusiness[1], setRecruitBusiness)
                                                    : activeStarRecruit(recruitBusiness[1], setRecruitBusiness);
                                            }}
                                        >
                                            <i
                                                className={`icon icon-star white ${recruitBusiness[1].isChoice === 'Y' ? 'active' : ''
                                                    }`}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {recruitBusiness && recruitBusiness.length > 2 && (
                            <div
                                className={`list-item ${grandBanner?.length > 0 ? 'list-item-4' : 'list-item-3'
                                    } large-full`}
                            >
                                <div className="item-content">
                                    <div className="item-main-content">
                                        <div className="item-logo">
                                            <RecruitLogoChecking
                                                folderName={'recruit_logo'}
                                                imgName={recruitBusiness[2].logo}
                                                alt="logo recruitBusiness"
                                                bizCompany={recruitBusiness[2].bizCompany}
                                            />
                                        </div>
                                        <div className="item-desc">{recruitBusiness[2].title}</div>
                                        <div className="item-tag">
                                            {recruitBusiness[2].recruitClass &&
                                                recruitBusiness[2].recruitClass.includes(',')
                                                ? recruitBusiness[2].recruitClass.split(',')[0] + ' 외'
                                                : recruitBusiness[2].recruitClass}{' '}
                                            | {recruitBusiness[2].regionSi}({recruitBusiness[2].regionGu}) |{' '}
                                            {recruitBusiness[2].recruitForm &&
                                                recruitBusiness[2].recruitForm.includes(',')
                                                ? recruitBusiness[2].recruitForm.split(',')[0] + ' 외'
                                                : recruitBusiness[2].recruitForm}
                                        </div>
                                        <button
                                            className="bookmark"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                recruitBusiness[2].isChoice === 'Y'
                                                    ? removeStar(recruitBusiness[2], setRecruitBusiness)
                                                    : activeStarRecruit(recruitBusiness[2], setRecruitBusiness);
                                            }}
                                        >
                                            <i
                                                className={`icon icon-star ${recruitBusiness[2].isChoice === 'Y' ? 'active' : ''
                                                    }`}
                                            />
                                        </button>
                                        <div className="item-image">
                                            <ImageCheckFallback
                                                folderName={'recruit_photo'}
                                                imgName={recruitBusiness[2]?.subBizImg?.split('|')[0]}
                                                alt="business banner"
                                            />
                                        </div>
                                    </div>
                                    <div className="item-hover-content">
                                        <a
                                            href={`/paeaa070-${recruitBusiness[2].seq}?bs=${recruitBusiness[2].bannerSeq}`}
                                            className="content-banner-hover"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                backgroundImage: `url(${getImageSrc(
                                                    'recruit_photo',
                                                    recruitBusiness[2]?.subBizImg?.split('|')[0],
                                                )})`,
                                            }}
                                        >
                                            <div className="content-banner-hover-logo">
                                                <RecruitLogoChecking
                                                    folderName={'recruit_logo'}
                                                    imgName={recruitBusiness[2].logo}
                                                    alt="logo recruitBusiness"
                                                    bizCompany={recruitBusiness[2].bizCompany}
                                                />
                                            </div>

                                            <div className="content-banner-hover-title">
                                                {recruitBusiness[2].bizCompany}
                                            </div>

                                            <div className="content-banner-hover-desc">
                                                {recruitBusiness[2].title}
                                            </div>
                                        </a>
                                        <button
                                            className="bookmark"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                recruitBusiness[2].isChoice === 'Y'
                                                    ? removeStar(recruitBusiness[2], setRecruitBusiness)
                                                    : activeStarRecruit(recruitBusiness[2], setRecruitBusiness);
                                            }}
                                        >
                                            <i
                                                className={`icon icon-star white ${recruitBusiness[2].isChoice === 'Y' ? 'active' : ''
                                                    }`}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {recruitGrand && recruitGrand.length > 0 ? (
                            recruitGrand.map((item, index) => (
                                <div className="list-item-wrap" key={`grand-banner-2-${index}`}>
                                    <div
                                        className={`list-item list-item-${5 + index} ${item.fixed !== 'Y' ? 'nor' : ''
                                            }`}
                                    >
                                        {item.type === 'GRANDBANNER' ? (
                                            <div className="item-content">
                                                <div>
                                                    <a
                                                        className="item-logo"
                                                        href={`/paeaa070-${item.seq}?bs=${item.bannerSeq}`}
                                                        target="_blank"
                                                    >
                                                        <RecruitLogoChecking
                                                            folderName={'recruit_logo'}
                                                            imgName={item.logo}
                                                            alt="logo recruit"
                                                            bizCompany={item.bizCompany}
                                                        />
                                                    </a>
                                                    <a
                                                        className="item-desc"
                                                        href={`/paeaa070-${item.seq}?bs=${item.bannerSeq}`}
                                                        target="_blank"
                                                    >
                                                        {decodeHTML(item.title)}
                                                    </a>
                                                    <div className="item-tag">
                                                        {item.recruitClass && item.recruitClass.includes(',')
                                                            ? item.recruitClass.split(',')[0] + ' 외'
                                                            : item.recruitClass}{' '}
                                                        | {item.regionSi}({item.regionGu}) |{' '}
                                                        {item.recruitForm && item.recruitForm.includes(',')
                                                            ? item.recruitForm.split(',')[0] + ' 외'
                                                            : item.recruitForm}
                                                    </div>
                                                    <button
                                                        className="bookmark"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            item.isChoice === 'Y'
                                                                ? removeStar(item, setRecruitGrand)
                                                                : activeStarRecruit(item, setRecruitGrand);
                                                        }}
                                                    >
                                                        <i
                                                            className={`icon icon-star ${item.isChoice === 'Y' ? 'active' : ''
                                                                }`}
                                                        />
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <a
                                                className="item-content"
                                                style={{ padding: '0px' }}
                                                href={
                                                    item?.linkType === 'window'
                                                        ? item?.linkWinName
                                                        : item?.linkUrl
                                                }
                                                rel="nofollow"
                                                target={
                                                    item?.linkType === 'window'
                                                        ? '_self'
                                                        : item?.linkType
                                                }
                                                onClick={async (e) => {
                                                    if (item?.linkType !== '_blank') {
                                                        e.preventDefault();
                                                    }
                                                    await putPAAAA010ClickBanner(item?.seq);
                                                    try {
                                                        if (item?.linkType === 'window') {
                                                            window.open(
                                                                item?.linkUrl,
                                                                '_blank',
                                                                'width=1200,height=1000',
                                                            );
                                                        } else if (item?.linkType !== '_blank') {
                                                            window.location.href = item?.linkUrl;
                                                        }
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}
                                            >
                                                <ImageCheckFallback
                                                    folderName={'banner_photo_grand'}
                                                    imgName={item?.logo}
                                                    alt="DentalJob"
                                                    classImg="main-grandsub"
                                                />
                                            </a>
                                        )}


                                    </div>
                                </div>
                            ))
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
                {loading ? (
                    <p className="center-loadding">
                        <Loader />
                    </p>
                ) : (
                    ''
                )}
            </div>
            {/* End Grand Banner */}
            {/* Premium Banner */}
            {recruitPremium !== null && recruitPremium.length > 0 && (
                <div id="premium-banner">
                    <div className="container">
                        <h1 className="section-title">프리미엄</h1>
                        <div className="list-grid">
                            {premiumBanner && premiumBanner.length > 0 && premiumBanner[0] && (
                                <div className="list-item-wrap" key={'premiumBanner-0'}>
                                    <div className="list-item full">
                                        <a
                                            className="item-content"
                                            href={
                                                premiumBanner[0]?.linkType === 'window'
                                                    ? premiumBanner[0]?.linkWinName
                                                    : premiumBanner[0]?.linkUrl
                                            }
                                            rel="nofollow"
                                            target={
                                                premiumBanner[0]?.linkType === 'window'
                                                    ? '_self'
                                                    : premiumBanner[0]?.linkType
                                            }
                                            onClick={async (e) => {
                                                if (premiumBanner[0]?.linkType !== '_blank') {
                                                    e.preventDefault();
                                                }
                                                await putPAAAA010ClickBanner(premiumBanner[0]?.seq);
                                                try {
                                                    if (premiumBanner[0]?.linkType === 'window') {
                                                        window.open(
                                                            premiumBanner[0]?.linkUrl,
                                                            '_blank',
                                                            'width=1200,height=1000',
                                                        );
                                                    } else if (premiumBanner[0]?.linkType !== '_blank') {
                                                        window.location.href = premiumBanner[0]?.linkUrl;
                                                    }
                                                } catch (error) {
                                                    console.log(error);
                                                }
                                            }}
                                        >
                                            <RecruitLogoChecking
                                                folderName={'banner_photo_premium'}
                                                imgName={premiumBanner[0]?.imgNameMain}
                                                alt="banner pre full"
                                            />
                                        </a>
                                    </div>
                                </div>
                            )}

                            {recruitPremium &&
                                recruitPremium.length > 4 &&
                                recruitPremium.slice(0, 4).map((item, index) => (
                                    <div className="list-item-wrap" key={`premium-banner-1-${item.seq}`}>
                                        <div className={`list-item ${item.fixed !== 'Y' ? 'nor' : ''}`}>
                                            <div className="item-content">
                                                <a
                                                    href={`/paeaa070-${item.seq}?bs=${item.bannerSeq}`}
                                                    className="item-logo"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <RecruitLogoChecking
                                                        folderName={'recruit_logo'}
                                                        imgName={item.logo}
                                                        alt="logo recruit"
                                                        bizCompany={item.bizCompany}
                                                    />
                                                </a>

                                                <a
                                                    className="item-desc"
                                                    href={`/paeaa070-${item.seq}?bs=${item.bannerSeq}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {decodeHTML(item.title)}
                                                </a>
                                                <div className="item-tag">
                                                    {item.recruitClass && item.recruitClass.includes(',')
                                                        ? item.recruitClass.split(',')[0] + ' 외'
                                                        : item.recruitClass}{' '}
                                                    | {item.regionSi}({item.regionGu}) |{' '}
                                                    {item.recruitForm && item.recruitForm.includes(',')
                                                        ? item.recruitForm.split(',')[0] + ' 외'
                                                        : item.recruitForm}
                                                </div>
                                                <button
                                                    className="bookmark"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        item.isChoice === 'Y'
                                                            ? removeStar(item, setRecruitPremium)
                                                            : activeStarRecruit(item, setRecruitPremium);
                                                    }}
                                                >
                                                    <i
                                                        className={`icon icon-star ${item.isChoice === 'Y' ? 'active' : ''
                                                            }`}
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            {premiumBanner && premiumBanner.length > 0 && premiumBanner[1] && (
                                <div className="list-item-wrap" key={'premiumBanner-1'}>
                                    <div className="list-item full">
                                        <a
                                            className="item-content"
                                            href={
                                                premiumBanner[1]?.linkType === 'window'
                                                    ? premiumBanner[1]?.linkWinName
                                                    : premiumBanner[1]?.linkUrl
                                            }
                                            rel="nofollow"
                                            target={
                                                premiumBanner[1]?.linkType === 'window'
                                                    ? '_self'
                                                    : premiumBanner[1]?.linkType
                                            }
                                            onClick={async (e) => {
                                                if (premiumBanner[1]?.linkType !== '_blank') {
                                                    e.preventDefault();
                                                }
                                                await putPAAAA010ClickBanner(premiumBanner[1]?.seq);
                                                try {
                                                    if (premiumBanner[1]?.linkType === 'window') {
                                                        window.open(
                                                            premiumBanner[1]?.linkUrl,
                                                            '_blank',
                                                            'width=1200,height=1000',
                                                        );
                                                    } else if (premiumBanner[1]?.linkType !== '_blank') {
                                                        window.location.href = premiumBanner[1]?.linkUrl;
                                                    }
                                                } catch (error) {
                                                    console.log(error);
                                                }
                                            }}
                                        >
                                            <RecruitLogoChecking
                                                folderName={'banner_photo_premium'}
                                                imgName={premiumBanner[1]?.imgNameMain}
                                                alt="banner pre full"
                                            />
                                        </a>
                                    </div>
                                </div>
                            )}

                            {recruitPremium &&
                                recruitPremium.length > 4 &&
                                recruitPremium.slice(4).map((item, index) => (
                                    <div className="list-item-wrap" key={`premium-banner-2-${index}`}>
                                        <div className={`list-item ${item.fixed !== 'Y' ? 'nor' : ''}`}>
                                            <div className="item-content">
                                                <a
                                                    href={`/paeaa070-${item.seq}?bs=${item.bannerSeq}`}
                                                    className="item-logo"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <RecruitLogoChecking
                                                        folderName={'recruit_logo'}
                                                        imgName={item.logo}
                                                        alt="logo recruit"
                                                        bizCompany={item.bizCompany}
                                                    />
                                                </a>

                                                <a
                                                    className="item-desc"
                                                    href={`/paeaa070-${item.seq}?bs=${item.bannerSeq}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {decodeHTML(item.title)}
                                                </a>
                                                <div className="item-tag">
                                                    {item.recruitClass && item.recruitClass.includes(',')
                                                        ? item.recruitClass.split(',')[0] + ' 외'
                                                        : item.recruitClass}{' '}
                                                    | {item.regionSi}({item.regionGu}) |{' '}
                                                    {item.recruitForm && item.recruitForm.includes(',')
                                                        ? item.recruitForm.split(',')[0] + ' 외'
                                                        : item.recruitForm}
                                                </div>
                                                <button
                                                    className="bookmark"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        item.isChoice === 'Y'
                                                            ? removeStar(item, setRecruitPremium)
                                                            : activeStarRecruit(item, setRecruitPremium);
                                                    }}
                                                >
                                                    <i
                                                        className={`icon icon-star ${item.isChoice === 'Y' ? 'active' : ''
                                                            }`}
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            {recruitPremium &&
                                recruitPremium.length > 0 &&
                                recruitPremium.length <= 4 &&
                                recruitPremium.map((item, index) => (
                                    <div className="list-item-wrap" key={`premium-banner-${index}`}>
                                        <div className={`list-item ${item.fixed !== 'Y' ? 'nor' : ''}`}>
                                            <div className="item-content">
                                                <Link
                                                    to={`/paeaa070-${item.seq}?bs=${item.bannerSeq}`}
                                                    className="item-logo"
                                                >
                                                    <RecruitLogoChecking
                                                        folderName={'recruit_logo'}
                                                        imgName={item.logo}
                                                        alt="logo recruit"
                                                        bizCompany={item.bizCompany}
                                                    />
                                                </Link>
                                                <Link
                                                    className="item-desc"
                                                    to={`/paeaa070-${item.seq}?bs=${item.bannerSeq}`}
                                                >
                                                    {decodeHTML(item.title)}
                                                </Link>
                                                <div className="item-tag">
                                                    {item.recruitClass && item.recruitClass.includes(',')
                                                        ? item.recruitClass.split(',')[0] + ' 외'
                                                        : item.recruitClass}{' '}
                                                    | {item.regionSi}({item.regionGu}) |{' '}
                                                    {item.recruitForm && item.recruitForm.includes(',')
                                                        ? item.recruitForm.split(',')[0] + ' 외'
                                                        : item.recruitForm}
                                                </div>
                                                <button
                                                    className="bookmark"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        item.isChoice === 'Y'
                                                            ? removeStar(item, setRecruitPremium)
                                                            : activeStarRecruit(item, setRecruitPremium);
                                                    }}
                                                >
                                                    <i
                                                        className={`icon icon-star ${item.isChoice === 'Y' ? 'active' : ''
                                                            }`}
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                    {loading && (
                        <div className="center-loadding">
                            <Loader />
                        </div>
                    )}
                </div>
            )}

            {/* End Premium Banner */}

            {/* Hot Recruit */}
            {recruitHot !== null && recruitHot.length > 0 && (
                <div id="hot-recruit">
                    <div className="container">
                        <h1 className="section-title">핫리쿠르트</h1>
                        <div className="list-grid">
                            {recruitHot.map((item, index) => (
                                <div className="list-item-wrap" key={`hot-recruit-${index}`}>
                                    <div className={`list-item ${item.fixed !== 'Y' ? 'nor' : ''}`}>
                                        <div className="item-content">
                                            <a
                                                className="item-title"
                                                href={`/paeaa070-${item.seq}?bs=${item.bannerSeq}`}
                                                target="_blank"
                                            >
                                                {item.bizCompany}
                                            </a>
                                            <a
                                                href={`/paeaa070-${item.seq}?bs=${item.bannerSeq}`}
                                                className="item-desc"
                                                target="_blank"
                                            >
                                                {decodeHTML(item.title)}
                                            </a>
                                            <div className="item-tag">
                                                {item.recruitClass && item.recruitClass.includes(',')
                                                    ? item.recruitClass.split(',')[0] + ' 외'
                                                    : item.recruitClass}{' '}
                                                | {item.regionSi}({item.regionGu}) |{' '}
                                                {item.recruitForm && item.recruitForm.includes(',')
                                                    ? item.recruitForm.split(',')[0] + ' 외'
                                                    : item.recruitForm}
                                            </div>
                                            <button
                                                className="bookmark"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    item.isChoice === 'Y'
                                                        ? removeStar(item, setRecruitHot)
                                                        : activeStarRecruit(item, setRecruitHot);
                                                }}
                                            >
                                                <i
                                                    className={`icon icon-star ${item.isChoice === 'Y' ? 'active' : ''
                                                        }`}
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
            {/* End Hot Recruit */}

            {/* Enterprise */}
            {recruitCorporate !== null && recruitCorporate.length > 0 && (
                <div id="enterprise">
                    <div className="container">
                        <h1 className="section-title">기업</h1>
                        <div className="list-grid">
                            {recruitCorporate.map((item, index) => (
                                <div className="list-item-wrap" key={'recruitCorporate' + index}>
                                    <div className="list-item nor">
                                        <div className="item-content">
                                            <div>
                                                <a
                                                    href={`/paeaa070-${item.seq}?bs=${item.bannerSeq}`}
                                                    className="item-title"
                                                    target="_blank"
                                                >
                                                    {item.bizCompany}
                                                </a>
                                                <a
                                                    className="item-desc"
                                                    href={`/paeaa070-${item.seq}?bs=${item.bannerSeq}`}
                                                    target="_blank"
                                                >
                                                    {item.title}
                                                </a>
                                                <div className="item-tag">
                                                    {item.recruitClass && item.recruitClass.includes(',')
                                                        ? item.recruitClass.split(',')[0] + ' 외'
                                                        : item.recruitClass}{' '}
                                                    | {item.regionSi}({item.regionGu}) |{' '}
                                                    {item.recruitForm && item.recruitForm.includes(',')
                                                        ? item.recruitForm.split(',')[0] + ' 외'
                                                        : item.recruitForm}
                                                </div>
                                                <button
                                                    className="bookmark"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        item.isChoice === 'Y'
                                                            ? removeStar(item, setRecruitCorporate)
                                                            : activeStarRecruit(item, setRecruitCorporate);
                                                    }}
                                                >
                                                    <i
                                                        className={`icon icon-star ${item.isChoice === 'Y' ? 'active' : ''
                                                            }`}
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {recruitCorporate.length % 2 !== 0 && corpBanner && corpBanner[0] && (
                                <div className="list-item-wrap item-corporate-banner">
                                    <div className="list-item full">
                                        <div className="item-content">
                                            <a
                                                href={
                                                    corpBanner[0]?.linkType === 'window'
                                                        ? corpBanner[0]?.linkWinName
                                                        : corpBanner[0]?.linkUrl
                                                }
                                                rel="nofollow"
                                                target={
                                                    corpBanner[0]?.linkType === 'window'
                                                        ? '_self'
                                                        : corpBanner[0]?.linkType
                                                }
                                                onClick={async (e) => {
                                                    if (corpBanner[0]?.linkType !== '_blank') {
                                                        e.preventDefault();
                                                    }
                                                    await putPAAAA010ClickBanner(corpBanner[0]?.seq);
                                                    try {
                                                        if (corpBanner[0]?.linkType === 'window') {
                                                            e.preventDefault();
                                                            window.open(
                                                                corpBanner[0]?.linkUrl,
                                                                '_blank',
                                                                'width=1200,height=1000',
                                                            );
                                                        } else if (corpBanner[0]?.linkType !== '_blank') {
                                                            window.location.href = corpBanner[0]?.linkUrl;
                                                        }
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}
                                            >
                                                <ImageCheckFallback
                                                    folderName={'banner_photo_corp'}
                                                    imgName={corpBanner[0]?.imgNameMain}
                                                    alt="banner enterprise"
                                                />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {/* End Enterprise */}

            {/* Hot Talent */}
            <div id="hot-talent">
                <div className="container">
                    <h1 className="section-title">HOT 인재</h1>
                    {loading && (
                        <div className="center-loadding">
                            <Loader />
                        </div>
                    )}
                    <div className="list-grid">
                        {resumesData &&
                            resumesData.length > 0 &&
                            resumesData.map((resume, idx) => [
                                <div className="list-item-wrap" key={`hot-talent-${idx}`}>
                                    <div className="list-item">
                                        <div className="item-content">
                                            <div className="item-header">
                                                <div className="item-info">
                                                    <div className="item-avatar">
                                                        {loggedIn && decode?.authorities !== 'ROLE_P' && resume?.logo ? (
                                                            <img
                                                                src={getImageSrc('resume_logo', resume.logo)}
                                                                alt="avatar"
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = './images/default-avatar-circle.png';
                                                                }}
                                                            />
                                                        ) : (
                                                            <img
                                                                src="./images/default-avatar-circle.png"
                                                                alt="avatar"
                                                            />
                                                        )}
                                                    </div>

                                                    <Link
                                                        onClick={(e) => {
                                                            if (!loggedIn) {
                                                                e.preventDefault();
                                                                alert('로그인 후 이용해주세요');
                                                            } else if (decode?.authorities === 'ROLE_P') {
                                                                e.preventDefault();
                                                                alert('인재정보는 치과회원만 확인하실 수 있습니다.');
                                                            }
                                                        }}
                                                        to={loggedIn && `/pafaa060-${resume.seq}?from=list`}
                                                        className="item-name"
                                                    >
                                                        {hideName(resume.nameKor)}
                                                    </Link>
                                                </div>
                                                <button
                                                    className="bookmark"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        resume.isChoice === 'Y'
                                                            ? removeStar(resume, setResumesData)
                                                            : activeStarResume(resume, setResumesData);
                                                    }}
                                                >
                                                    <i
                                                        className={`icon icon-star ${resume.isChoice === 'Y' ? 'active' : ''
                                                            }`}
                                                    />
                                                </button>
                                            </div>
                                            <Link
                                                onClick={(e) => {
                                                    if (!loggedIn) {
                                                        e.preventDefault();
                                                        alert('로그인 후 이용해주세요');
                                                    } else if (decode?.authorities === 'ROLE_P') {
                                                        e.preventDefault();
                                                        alert('인재정보는 치과회원만 확인하실 수 있습니다.');
                                                    }
                                                }}
                                                to={loggedIn && `/pafaa060-${resume.seq}?from=list`}
                                                className="item-desc"
                                            >
                                                {resume.title}
                                            </Link>
                                            <div className="item-footer">
                                                <div className="item-tag">{ResumeClassDisplay(resume.resumeClass)}</div>
                                                <div className="item-tag">
                                                    {resume.resumeCareer === '001' ? '신입' : '경력'}
                                                    {resume.resumeForm && ` | ${resume.resumeForm}`}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>,
                            ])}
                        <div className={`list-item-wrap item-9 ${hotBanner.length === 0 ? 'no-select' : ''}`}>
                            <div className="list-item full list-item-5 no-after">
                                {hotBanner && hotBanner[0] && (
                                    <div className="item-content">
                                        <a
                                            href={
                                                hotBanner[0]?.linkType === 'window'
                                                    ? hotBanner[0]?.linkWinName
                                                    : hotBanner[0]?.linkUrl
                                            }
                                            rel="nofollow"
                                            target={
                                                hotBanner[0]?.linkType === 'window' ? '_self' : hotBanner[0]?.linkType
                                            }
                                            onClick={async (e) => {
                                                if (hotBanner[0]?.linkType !== '_blank') {
                                                    e.preventDefault();
                                                }
                                                await putPAAAA010ClickBanner(hotBanner[0]?.seq);
                                                try {
                                                    if (hotBanner[0]?.linkType === 'window') {
                                                        e.preventDefault();
                                                        window.open(
                                                            hotBanner[0]?.linkUrl,
                                                            '_blank',
                                                            'width=1200,height=1000',
                                                        );
                                                    } else if (hotBanner[0]?.linkType !== '_blank') {
                                                        window.location.href = hotBanner[0]?.linkUrl;
                                                    }
                                                } catch (error) {
                                                    console.log(error);
                                                }
                                            }}
                                        >
                                            <ImageCheckFallback
                                                folderName={'banner_photo_mainresume'}
                                                imgName={hotBanner[0]?.imgNameMain}
                                                alt="banner pre full"
                                            />
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={`list-item-wrap item-10 ${hotBanner.length <= 1 ? 'no-select' : ''}`}>
                            <div className="list-item full list-item-10 no-after">
                                {hotBanner && hotBanner[1] && (
                                    <div className="item-content">
                                        <a
                                            href={
                                                hotBanner[1]?.linkType === 'window'
                                                    ? hotBanner[1]?.linkWinName
                                                    : hotBanner[1]?.linkUrl
                                            }
                                            rel="nofollow"
                                            target={
                                                hotBanner[1]?.linkType === 'window' ? '_self' : hotBanner[1]?.linkType
                                            }
                                            onClick={async (e) => {
                                                if (hotBanner[1]?.linkType !== '_blank') {
                                                    e.preventDefault();
                                                }
                                                await putPAAAA010ClickBanner(hotBanner[1]?.seq);
                                                try {
                                                    if (hotBanner[1]?.linkType === 'window') {
                                                        e.preventDefault();
                                                        window.open(
                                                            hotBanner[1]?.linkUrl,
                                                            '_blank',
                                                            'width=1200,height=1000',
                                                        );
                                                    } else if (hotBanner[1]?.linkType !== '_blank') {
                                                        window.location.href = hotBanner[1]?.linkUrl;
                                                    }
                                                } catch (error) {
                                                    console.log(error);
                                                }
                                            }}
                                        >
                                            <ImageCheckFallback
                                                folderName={'banner_photo_mainresume'}
                                                imgName={hotBanner[1]?.imgNameMain}
                                                alt="banner pre full"
                                            />
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="drop-list-item-res">
                        <div className="btn-drop-list" onClick={() => handleDropList()}>
                            <div className="drop-text">더보기</div>
                        </div>
                    </div>
                </div>
            </div>
            {/* End Hot Talent */}
            {/* Bottom Nav */}
            <div id="bottom-nav">
                <div className="container">
                    <div className="bottom-nav-wrap">
                        <Link to="/pagaj010" className="bottom-nav-item">
                            <i className="icon icon-docs" />
                            <div className="wrap-nav-title">
                                <div className="bottom-nav-title">법정의무교육</div>
                                <div className="bottom-nav-desc">간편하게 이수할 수 있는 필수교육을 제공합니다.</div>
                            </div>
                        </Link>
                        {shouldDisplayMenu('pahad010', menuData) && (
                            <Link to="/pahad010" className="bottom-nav-item">
                                <i className="icon icon-letter" />
                                <div className="wrap-nav-title">
                                    <div className="bottom-nav-title">이메일 문의</div>
                                    <div className="bottom-nav-desc letter-spacing-05">
                                        빠르고 정확한 답변을 제공해 드리겠습니다.
                                    </div>
                                </div>
                            </Link>
                        )}
                        {shouldDisplayMenu('pahae010', menuData) && (
                            <Link to="/pahae010" className="bottom-nav-item">
                                <i className="icon icon-mess" />
                                <div className="wrap-nav-title">
                                    <div className="bottom-nav-title">자주 묻는 질문</div>
                                    <div className="bottom-nav-desc">
                                        자주 묻는 질문에 대한 답변을 확인 할 수 있습니다.
                                    </div>
                                </div>
                            </Link>
                        )}
                        <Link to="/pahaa010" className="bottom-nav-item">
                            <i className="icon icon-contact" />
                            <div className="wrap-nav-title">
                                <div className="bottom-nav-title">고객센터</div>
                                <div className="phone-number">080-801-1580</div>
                                <div className="bottom-nav-desc">
                                    평일(월~금) 09:00~17:30
                                    <br />
                                    토·일·공휴일 휴무 TEL: 080-801-1580
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
            {/* End Bottom Nav */}
        </div>
    );
};

export default PAAAA010;
